module.exports = __webpack_public_path__ + "static/media/f_hairstyle_curly_long_back.009296ff.png";